import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93273570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calling-wrapper" }
const _hoisted_2 = { class: "tag" }
const _hoisted_3 = { class: "microphone-icon-container" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = { class: "microphone-icon-container" }

import { TUICallKitServer } from "../index";
import { onMounted, ref, nextTick } from "vue";
import { remoteList, profile, t, getVolumeByUserID } from "../store/index";
import MicrophoneIcon from "./MicrophoneIcon.vue";
import Switch2SVG from "../icons/switch2.vue";
import MicrophoneClosedSVG from "../icons/microphoneClosed.vue";
import { isMobile } from "../utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'Calling-C2CVideo',
  setup(__props) {

onMounted(async () => {
  await TUICallKitServer.renderLocal();
  await TUICallKitServer.renderRemoteWaitList();
});

const localClass = ref("small");
const localClassH5 = ref("small-h5");
const remoteClass = ref("large");

const switchUserView = async () => {
  if (isMobile) {
    [localClassH5.value, remoteClass.value] = [remoteClass.value, localClassH5.value];
  } else {
    [localClass.value, remoteClass.value] = [remoteClass.value, localClass.value];
    await nextTick();
    // reset to default size
    const largeView = document.getElementsByClassName("large")[0] as HTMLElement;
    const smallView = document.getElementsByClassName("small")[0] as HTMLElement;
    smallView.style.height = "170px";
    smallView.style.width = "260px";
    largeView.style.height = "100%";
    largeView.style.width = "100%";
  }
}

const h5SwitchUserView = async () => { 
  if (!isMobile) return;
  switchUserView();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "local-c2c",
      class: _normalizeClass(_unref(isMobile) ? localClassH5.value : localClass.value),
      onClick: h5SwitchUserView
    }, [
      _withDirectives(_createElementVNode("span", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(profile)?.microphone)
            ? (_openBlock(), _createBlock(MicrophoneIcon, {
                key: 0,
                volume: _unref(getVolumeByUserID)(_unref(profile).userID)
              }, null, 8, ["volume"]))
            : (_openBlock(), _createBlock(MicrophoneClosedSVG, { key: 1 }))
        ]),
        _createTextVNode(" " + _toDisplayString(`${_unref(profile)?.nick} ${_unref(t)('me')}`), 1)
      ], 512), [
        [_vShow, !_unref(isMobile)]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "switch-large-small",
        onClick: switchUserView
      }, [
        _createVNode(Switch2SVG)
      ], 512), [
        [_vShow, !_unref(isMobile)]
      ])
    ], 2),
    (_unref(remoteList).length >= 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _unref(remoteList)[0].userID,
          class: _normalizeClass(remoteClass.value),
          onClick: h5SwitchUserView
        }, [
          _withDirectives(_createElementVNode("span", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_unref(remoteList)[0]?.microphone)
                ? (_openBlock(), _createBlock(MicrophoneIcon, {
                    key: 0,
                    volume: _unref(getVolumeByUserID)(_unref(remoteList)[0]?.userID)
                  }, null, 8, ["volume"]))
                : (_openBlock(), _createBlock(MicrophoneClosedSVG, { key: 1 }))
            ]),
            _createTextVNode(" " + _toDisplayString(_unref(remoteList)[0]?.nick), 1)
          ], 512), [
            [_vShow, !_unref(isMobile)]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "switch-large-small",
            onClick: switchUserView
          }, [
            _createVNode(Switch2SVG)
          ], 512), [
            [_vShow, !_unref(isMobile)]
          ])
        ], 10, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})